import { DASHBOARD_DATA } from "../types";

export const dashBoardAction = (data, onSuccess, onError) => {
    return {
      type: DASHBOARD_DATA,
      data,
      onSuccess,
      onError,
    };
  };